module.exports = __webpack_public_path__ + "images/thumb-e4dc80dc2c43c2562e1a0259f94ef03d.jpg";